import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import {
  createInitialSidebarState,
  writeStoredSidebarCollapsed,
} from './sidebar.state.utils'

const sidebarSlice = createSlice({
  name: 'taskTrackerSidebar',
  initialState: createInitialSidebarState(),
  reducers: {
    toggleSidebarCollapsed(state) {
      state.collapsed = !state.collapsed
      writeStoredSidebarCollapsed(state.collapsed)
    },
    setSidebarCollapsed(state, action: PayloadAction<boolean>) {
      state.collapsed = action.payload
      writeStoredSidebarCollapsed(action.payload)
    },
  },
})

export const { toggleSidebarCollapsed, setSidebarCollapsed } =
  sidebarSlice.actions

export default sidebarSlice.reducer
